fragment NumbersOnBlackBackgroundFragment on numbersOnBlackBackground_Entry {
  typeHandle
  heading
  tiles: educationNumberTiles {
    ... on educationNumberTilesBlock_Entry {
      id
      numericValue
      body
    }
  }
}
